"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateGrain = void 0;
var DateGrain;
(function (DateGrain) {
    DateGrain["DAY"] = "day";
    DateGrain["WEEK"] = "week";
    DateGrain["MONTH"] = "month";
    DateGrain["QUARTER"] = "quarter";
    DateGrain["YEAR"] = "year";
})(DateGrain = exports.DateGrain || (exports.DateGrain = {}));
